import React, { Suspense } from 'react';
import { JssProvider, ThemeProvider } from 'react-jss';

import './i18n';

import ceateTheme from './theme';
import CssBaseLine from './components/CssBaseline';

import { renderRoutes } from 'react-router-config';

function App({ route }) {
  return (
    <JssProvider>
      <ThemeProvider theme={ceateTheme()}>
        <Suspense fallback={<></>}>
          <CssBaseLine />
          {renderRoutes(route.routes)}
        </Suspense>
      </ThemeProvider>
    </JssProvider>
  );
}

export default App;
